import { isWorkingDay } from './calendar.js';

/**
 * Inclusive working-day count between two ISO dates on the KSA calendar:
 * Sunday–Thursday week, public holidays excluded (both Eids resolved through
 * the Umm al-Qura calendar). Pure; the basis of leave arithmetic (P5).
 */
const MS_PER_DAY = 86_400_000;

export function workingDaysBetween(startIso: string, endIso: string): number {
  const start = Date.parse(`${startIso}T00:00:00Z`);
  const end = Date.parse(`${endIso}T00:00:00Z`);
  if (Number.isNaN(start) || Number.isNaN(end)) {
    throw new RangeError(`Invalid ISO dates: ${startIso} → ${endIso}`);
  }
  if (end < start) throw new RangeError(`End ${endIso} precedes start ${startIso}`);

  let count = 0;
  for (let t = start; t <= end; t += MS_PER_DAY) {
    if (isWorkingDay(new Date(t))) count++;
  }
  return count;
}
